// export const myGetter =  ( state ) => {
//  return state
// }

export const getAuthToken = (state) => {
    return state.auth_token;
}

export const getUserEmail = (state) => {
    return state.user?.email;
}

export const getUserID = (state) => {
    return state.user?.id;
}

export const getUserName = (state) => {
    return state.user?.name;
}

export const getUserRol = (state) => {
    return state.user?.rol;
}

export const isLoggedIn = (state) => {
    const loggedOut =
        state.auth_token == null || state.auth_token == JSON.stringify(null);
    return !loggedOut;
}

export const currentState = (state) => {
    return state.status;
}